exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReportPopup_heading_L7OU {}\n\n.ReportPopup_subtitle_2mk3 {\n  margin-top: -20px;\n  margin-bottom: 20px;\n}\n\n.ReportPopup_formatSelector_3KCk {\n  position: relative;\n  margin-bottom: 40px;\n}\n\n.ReportPopup_formatSelectorTitle_2juq {\n  margin-bottom: 15px;\n}\n\n.ReportPopup_saveSettings_3EY6 {\n  margin-bottom: 50px;\n}\n\n.ReportPopup_emailCheckbox_jFLW {\n  display: inline-block;\n\n  line-height: 1;\n}\n\n.ReportPopup_emailMessage_3AGK {\n  margin-top: 10px;\n}\n\n.ReportPopup_preloader_26Pv {\n  position: relative;\n\n  height: 226px;\n}\n", ""]);

// exports
exports.locals = {
	"heading": "ReportPopup_heading_L7OU",
	"subtitle": "ReportPopup_subtitle_2mk3",
	"formatSelector": "ReportPopup_formatSelector_3KCk",
	"formatSelectorTitle": "ReportPopup_formatSelectorTitle_2juq",
	"saveSettings": "ReportPopup_saveSettings_3EY6",
	"emailCheckbox": "ReportPopup_emailCheckbox_jFLW",
	"emailMessage": "ReportPopup_emailMessage_3AGK",
	"preloader": "ReportPopup_preloader_26Pv"
};